import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { truckDetailLayoutRoutes } from './lib.routes';
import { TruckDetailComponent } from './truck-detail/truck-detail.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonUiModule } from '@bst-frontend/common-ui';
import { UpdateLrComponent } from './modals/update-lr/update-lr.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(truckDetailLayoutRoutes),
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    CommonUiModule,
  ],
  declarations: [TruckDetailComponent, UpdateLrComponent, UpdateLrComponent],
  exports: [],
})
export class OrderDetailLayoutModule {}
